var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mt-5"},[_c('h1',[_vm._v(" "+_vm._s(_vm.$t("tac.title")))])]),_vm._m(0),_c('div',{staticClass:"col-md-12"},[_c('p',[_vm._v(_vm._s(_vm.$t("tac.body")))])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12 mb-3"},[_c('hr')])
}]

export { render, staticRenderFns }